import { useContext, useCallback } from 'react'
import { AppContext } from '../context/AppProvider'
import { collectionsLodingFetch, collectionsSuccessFetch, collectionsFailedFetch, collectionsDelete, collectionsAdd, collectionsUpdate } from '../actions/collectiosActions'
import { buildPrivateApiUrl } from '../config/api'

export const useCollections = () => {
  const { state, dispatch } = useContext(AppContext)

  const apiUrl = buildPrivateApiUrl('collections')

  const fetchCollections = useCallback(async () => {
    const token = localStorage.getItem('token')
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      dispatch(collectionsLodingFetch())
      try {
        const response = await fetch(apiUrl, {
          headers: { ...headers, Authorization: `${token}` }
        })
        if (response.ok) {
          const data = await response.json()

          dispatch(collectionsSuccessFetch(data))
        } else {
          console.error('Error with status code:', response.status)
          dispatch(collectionsFailedFetch('Something went wrong'))
        }
      } catch (error) {
        console.error('Failed to fetch brands:', error)
        dispatch(collectionsFailedFetch(error))
      }
    }
  }, [])

  const updateCollections = useCallback(async (payload) => {
    const token = localStorage.getItem('token')
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      try {
        const response = await fetch(apiUrl, {
          method: 'PUT',
          headers,
          body: JSON.stringify({ data: [payload] })
        })
        if (response.ok) {
          const { data } = await response.json()
          dispatch(collectionsUpdate(data[0]))
        } else {
          console.error('Error with status code:', response.status)
        }
      } catch (error) {
        console.error('Login error:', error)
      }
    }
  }, [])

  const addCollections = useCallback(async (payload) => {
    const token = localStorage.getItem('token')
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers,
          body: JSON.stringify({ data: [payload] })
        })
        if (response.ok) {
          const { data } = await response.json()
          dispatch(collectionsAdd(data[0]))
        } else {
          console.error('Error with status code:', response.status)
        }
      } catch (error) {
        console.error('Login error:', error)
      }
    }
  }, [])

  const deleteCollections = async (collectionId) => {
    const token = localStorage.getItem('token')
    let headers = { 'Content-Type': 'application/json' }
    if (token) {
      headers = { ...headers, Authorization: `${token}` }
      try {
        const response = await fetch(apiUrl, {
          method: 'DELETE',
          headers,
          body: JSON.stringify({ data: [collectionId._id] })
        })
        if (response.ok) {
          const { data } = await response.json()
          dispatch(collectionsDelete(collectionId))
          console.log(data)
        } else {
          console.error('Error with status code:', response.status)
        }
      } catch (error) {
        console.error('Login error:', error)
      }
    }
  }

  return { state, fetchCollections, addCollections, deleteCollections, updateCollections }
}
